import React, { useEffect, useState } from "react";
import { ReactComponent as Verify } from "../../../../assets/icons/verify.svg";
import SearchlistIcon from "../../../../assets/icons/searchlisticon.png";
import { ReactComponent as Manufacture } from "../../../../assets/images/manufacture.svg";
import { ReactComponent as ArrowRightYellow } from "../../../../assets/images/ArrowRightYellow.svg";
import { ReactComponent as Rocket } from "../../../../assets/images/rocket.svg";
import { Countries } from "../../../public/Home/CountryFlag";
import { Modal } from "../../../common";
import FollowPopup from "./FollowPopup";
import { Link } from "react-router-dom";
import { getCountryByCode } from "../../../../utils/Helper";
import { useGetCompanyUpdatesQuery } from "../../../../store/Company/companyApiSlice";
import { useSelector } from "react-redux";
import { formatDateWithOrdinalAndShortMonth } from "../../../../utils/Helper";
import { useGetCompanyNewQuery } from "../../../../store/search/searchApiSlice";
import { toSentenceCaseCP } from "../../../../global_functions/global";


export const FollowedCompanyCard = ({ company, follow }) => {
  const [flag, setFlag] = useState({});
//Note:It is inside the map calling API Multiple times, need to fix the issue
  const { data: worldboxData } = useGetCompanyNewQuery(
    { id: company?.wb_win },
    { skip: !company }
  );

  useEffect(() => {
    Countries.filter((county) => {
      if (county.code === company?.country_code) {
        setFlag(county.file_url);
      }
    });
  }, []);

  const [isOpen, setIsOpen] = useState(false);

  const modalHandle = (e) => {
    setIsOpen(!isOpen);
  };
  const redirectocompany = (companyID) => {
    const url = `/search/${companyID}`;
    window.open(url, "_blank");
  }

  const { token } = useSelector((state) => state.auth);

  const followedCompanyID = company?.companyID;
  const { data: companyUpdates, error, isLoading } = useGetCompanyUpdatesQuery({ companyID: followedCompanyID, token });
  const filteredUpdatesCount = companyUpdates ? companyUpdates.filter(update => update.content !== "Company Profile Updated").length : 0;

  let latestUpdateDate;

  if (companyUpdates) {
    const filteredUpdates = companyUpdates.filter(update => update.content !== "Company Profile Updated");
    filteredUpdates.sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));
    latestUpdateDate = filteredUpdates.length > 0 ? filteredUpdates[0].timestamp : null;
  }

  const showUpdatesNotification = new Date(follow?.viewed_timestamp) < new Date(latestUpdateDate);

  const updatesAfterLastView = companyUpdates ? companyUpdates.filter(update =>
    new Date(update.timestamp) > new Date(follow?.viewed_timestamp) &&
    update.content !== "Company Profile Updated"
  ) : [];

  const newUpdatesCount = updatesAfterLastView.length;

  return (
    <div>
      {isOpen && (
        <Modal modalHandle={modalHandle}>
          <FollowPopup close={modalHandle} redirectComp={() => redirectocompany(company?.companyID)} companyID={company?.companyID} follow={follow} />
        </Modal>
      )}
      <div className="bg-white border mt-5 border-gray-200 rounded-lg pareek">
        <div className="p-4 sm:p-5">
          <div className="grid md:grid-cols-5 sm:grid-cols-4 grid-cols-1 gap-2 text-left">
            <div className="lg:col-span-4 md:col-span-3 sm:col-span-2 lg:border-r sm:border-r-1 col-span-1">
              <div className="company flex justify-start gap-4">
                <div className="imageicon flex justify-center items-center ">
                  <img
                    src={company?.logo || SearchlistIcon}
                    style={{ width: '96px', height: '96px' }}
                    className="w-full rounded-lg"
                    alt={company?.registered_company_name}
                  />
                </div>
                <div className="mapdetails w-[80%] flex flex-col items-start justify-around">
                  {company?.registered_company_name && (
                    <div>
                      <h3 className="sm:text-para3 text-f18 text-secondarytwo font-bold">
                        {company?.registered_company_name}
                      </h3>
                      {latestUpdateDate &&
                        <p className="text-f10">
                          Last Update on: {formatDateWithOrdinalAndShortMonth(latestUpdateDate)}
                        </p>}
                    </div>
                  )}

                  {company?.industry_details?.sector && (
                    <p className="text-primaryText bg-greyFade font-semibold text-f12 mt-2 w-full sm:flex items-center px-3 capitalize py-1 rounded-2xl gap-3 tracking-subheading break-words">
                      <Rocket className="sm:w-auto w-16" /> {toSentenceCaseCP(company?.industry_details?.sector)}{" "}
                      {" | "} {company?.industry_details?.sub_industry}
                    </p>
                  )}

                  <div className="flex items-center pt-2 sm:pt-0 gap-2 mt-2">
                    <div className="flex text-secondary p-1 rounded-full">
                      <span className="sm:text-f12 block text-secondarytwo text-f12 tracking-subheading font-normal flex items-center">
                        {flag && (
                          <img
                            src={flag}
                            width="20px"
                            height="auto"
                            className="mr-2 h-6"
                            alt="hello"
                          />
                        )}
                        {
                          !company?.first_address_state ? (
                            <p>{!company?.claimed && worldboxData != undefined && worldboxData?.company?.city != undefined && worldboxData?.company?.city != '' && toSentenceCaseCP(worldboxData?.company?.city) + ", "} {getCountryByCode(company?.country_code)}</p>
                          ) : (
                            <p>{company?.first_address_state}, {getCountryByCode(company?.country_code)}</p>
                          )
                        }

                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {company?.company_description && (
              <p className="text-primaryText sm:hidden bg-greyFade font-semibold text-f12 mt-5 w-full flex items-center px-3 uppercase py-1 rounded-2xl gap-3 tracking-subheading truncate">
                <Manufacture /> {company?.company_description}
              </p>
            )}

            <div className="view_profile lg:col-span-1 sm:col-span-2 col-span-1 flex sm:pt-0 pt-2 sm:flex-col items-end justify-around">
              <Link
                to={`/search/${company?.companyID}`}
                target="_blank"
                className="flex items-center gap-2 mx-auto mr-0 text-link border group border-link rounded bg-white font-sans sm:text-f12 px-6 py-2 font-bold "
              >
                <span>View more</span>
                <svg
                  width="13"
                  height="12"
                  viewBox="0 0 13 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1.5 11L11.5 1M11.5 1H4M11.5 1V8.5"
                    stroke="#002940"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </Link>
            </div>
          </div>
        </div>
        {showUpdatesNotification && newUpdatesCount > 0 && (
          <div className="w-full bg-company p-2 sm:px-5 rounded-b-lg text-f14 flex items-center justify-between">
            <div className=" tracking-subheading text-left text-slate sm:w-3/4">
              {newUpdatesCount} new update{newUpdatesCount !== 1 ? "s" : ""} in this company profile.
            </div>
            <div
              className="text-updates font-semibold flex sm:w-1/4 gap-2 justify-end cursor-pointer"
              onClick={modalHandle}
            >
              View Updates <ArrowRightYellow />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
